import { baseApi } from "~/app/store/baseApi";
import type { LinearConfigurationDTO } from "~/features/configurator/Linear/dtos";
import type { ConfiguratorPageCustomization } from "~/features/configurator/common/components/ConfiguratorPageCustomizationContext";

export interface ConfiguratorInitResult {
  data: LinearConfigurationDTO;
  customization: ConfiguratorPageCustomization;
  helpUrl: string;
}

export interface ConfiguratorInitRequest {
  productCode: string;
}

export const configuratorInitApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    initConfiguration: builder.mutation<ConfiguratorInitResult, ConfiguratorInitRequest>({
      query: (body) => ({
        url: "/cpq/init",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useInitConfigurationMutation } = configuratorInitApi;
